@if ((loader.isLoading$ | async)) {
  <div class="spinner-overlay" data-testid="app-loader">
    @if ((loader.uploadPercentage$ | async) === 0) {
      <mat-spinner diameter="50"></mat-spinner>
    }
    @if ((loader.uploadPercentage$ | async); as uploadPercentage) {
      @if (uploadPercentage > 0) {
        <mat-spinner mode="determinate" [value]="uploadPercentage" diameter="50"></mat-spinner>
      }
    }
  </div>
}